import { Box } from "@mui/material";
import React, { FC } from "react";
import { COLOR_GREY_11 } from "shared/theme/colors";
import { StyledTicketTitle } from "../../styled";

type Props = {
  title: string;
};

const TicketTitle: FC<Props> = ({ title }) => {
  return (
    <Box ml={3}>
      <StyledTicketTitle variant="bodyMRegular" color={COLOR_GREY_11}>
        {title}
      </StyledTicketTitle>
    </Box>
  );
};

export default TicketTitle;
